module.exports = __webpack_public_path__ + "static/media/no-comments-placeholder-image.b28ab137.webp";